var Config;

Config = require('./Config');

module.exports = {
  getUrl: function(name, size) {
    return (Config.FilesBaseUrl()) + "/photos/" + name.slice(0, 2) + "/" + name + "." + size + ".jpg";
  }
};

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiL2FwcC9zcmMvbGliL1VybEhlbHBlci5jb2ZmZWUiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIvYXBwL3NyYy9saWIvVXJsSGVscGVyLmNvZmZlZSJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQSxJQUFBOztBQUFBLE1BQUEsR0FBUyxPQUFBLENBQVEsVUFBUjs7QUFFVCxNQUFNLENBQUMsT0FBUCxHQUFpQjtFQUNoQixNQUFBLEVBQVEsU0FBQyxJQUFELEVBQU8sSUFBUDtXQUFrQixDQUFDLE1BQU0sQ0FBQyxZQUFQLENBQUEsQ0FBRCxDQUFBLEdBQXVCLFVBQXZCLEdBQWlDLElBQUssWUFBdEMsR0FBNEMsR0FBNUMsR0FBK0MsSUFBL0MsR0FBb0QsR0FBcEQsR0FBdUQsSUFBdkQsR0FBNEQ7RUFBOUUsQ0FEUSJ9
